import LaunchIcon from '@mui/icons-material/Launch';
import { Link, Stack } from '@mui/material';
import { useGetIdentity, useRecordContext } from 'react-admin';
import { useWatch } from 'react-hook-form';

import { Supplier } from '../types';

const erpLinkSx = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
} as const;

export const usePersonErpBaseUrl = () => {
    const { identity } = useGetIdentity();
    return identity?.homologacao
        ? 'https://sandbox.rnge.com.br/app/index.html#/'
        : 'https://app.rnge.com.br/#/';
};

export const PersonErpLink = () => {
    const record = useRecordContext<Supplier>();
    const baseUrl = usePersonErpBaseUrl();

    if (!record?.id_pessoa) return null;

    const label = [record.id_pessoa, record.nome_razao]
        .filter(Boolean)
        .join('. ');

    return (
        <Link
            href={`${baseUrl}persons/${record.id_pessoa}`}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            variant="body2"
            onClick={e => e.stopPropagation()}
            sx={erpLinkSx}
        >
            {label}
            <LaunchIcon sx={{ fontSize: 16 }} />
        </Link>
    );
};

/** Atalhos ERP abaixo do autocomplete de pessoa (criar / abrir selecionada). */
export const PersonReferenceShortcuts = ({
    source = 'id_pessoa',
}: {
    source?: string;
}) => {
    const baseUrl = usePersonErpBaseUrl();
    const idPessoa = useWatch({ name: source });

    return (
        <Stack direction="row" alignItems="center" gap={1.5} flexWrap="wrap">
            {idPessoa != null && idPessoa !== '' ? (
                <Link
                    href={`${baseUrl}persons/${idPessoa}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                    variant="caption"
                    onClick={e => e.stopPropagation()}
                    sx={erpLinkSx}
                >
                    Abrir pessoa {idPessoa}
                    <LaunchIcon sx={{ fontSize: 14 }} />
                </Link>
            ) : null}
            <Link
                href={`${baseUrl}persons/create`}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                variant="caption"
                onClick={e => e.stopPropagation()}
                sx={erpLinkSx}
            >
                Cadastrar pessoa
                <LaunchIcon sx={{ fontSize: 14 }} />
            </Link>
        </Stack>
    );
};
